import { render, staticRenderFns } from "./PostingTypeSelect.vue?vue&type=template&id=149b31be"
import script from "./PostingTypeSelect.vue?vue&type=script&lang=js"
export * from "./PostingTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports